// ─── Vocabulaire CANONIQUE d'un élément (Core) ────────────────────
// Un élément (calendrier, inventaire, plan, espace…) porte les MÊMES noms de
// champs partout dans la suite. C'est le vocabulaire de référence : les
// services n'écrivent que lui, plus aucun alias.
//
// La convergence est FAITE (2026-08) :
//   • les documents existants ont été migrés — `scripts/migrer-canon.js` ;
//   • MoPCal, qui reste la référence de comparaison, écrit le canon et traduit
//     en lecture à sa frontière (`services/inventaires.js`, `calendriers.js`).
// Les alias restent lus ici, et seulement ici : ils couvrent un document ancien
// que la migration n'aurait pas touché, et les FICHIERS d'import (io.js), qui
// peuvent avoir été exportés avant la bascule.
//
//   CANON            ALIAS HISTORIQUES (lecture seule)
//   nom              titre (inventaires, plans)
//   emoji            icone (calendriers MoPCal)
//   proprietaire     creePar, ownerUid
//   espaceId         —

export const CANON = {
  nom: ['nom', 'titre'],
  emoji: ['emoji', 'icone'],
  proprietaire: ['creePar', 'ownerUid'],
};

const premier = (doc, cles, defaut) => {
  for (const c of cles) {
    const v = doc?.[c];
    if (v !== undefined && v !== null && v !== '') return v;
  }
  return defaut;
};

// Traduit un document (calendrier, inventaire, plan, espace…) vers le canon.
// `type` sert à composer la clé d'élément des jetons (« calendrier:abc »).
export function normaliserElement(doc, type) {
  if (!doc) return null;
  return {
    ...doc,
    id: doc.id,
    type,
    cle: type ? `${type}:${doc.id}` : doc.id,
    nom: premier(doc, CANON.nom, doc.id),
    emoji: premier(doc, CANON.emoji, ''),
    proprietaire: premier(doc, CANON.proprietaire, null),
    espaceId: doc.espaceId || null,
  };
}

export const nomDeElement = (doc) => premier(doc, CANON.nom, doc?.id || '');
export const emojiDeElement = (doc, defaut = '') => premier(doc, CANON.emoji, defaut);
export const proprietaireDe = (doc) => premier(doc, CANON.proprietaire, null);
